import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/partner/banner.jpg';
import _imports_1 from '@/assets/img/partner/banner_h5.jpg';
import _imports_2 from '@/assets/img/partner/5_02.jpg';
import _imports_3 from '@/assets/img/partner/5_02-750.jpg';
import _imports_4 from '@/assets/img/partner/5_03.jpg';
import _imports_5 from '@/assets/img/partner/5_03-750.jpg';
import _imports_6 from '@/assets/img/partner/5_04.jpg';
import _imports_7 from '@/assets/img/partner/5_04-750.jpg';
import _imports_8 from '@/assets/img/about/bt.jpg';
import _imports_9 from '@/assets/img/about/bt-750.jpg';
const _withScopeId = n => (_pushScopeId("data-v-388d1183"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "partner"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"banner_box\" data-v-388d1183><img class=\"hidden-xs-only banner\" src=\"" + _imports_0 + "\" alt=\"\" data-v-388d1183><img class=\"hidden-sm-and-up banner\" src=\"" + _imports_1 + "\" alt=\"\" data-v-388d1183></div><div class=\"\" data-v-388d1183><img class=\"hidden-xs-only\" src=\"" + _imports_2 + "\" data-v-388d1183> <img class=\"hidden-sm-and-up\" src=\"" + _imports_3 + "\" alt=\"\" data-v-388d1183></div><div class=\"\" data-v-388d1183><img class=\"hidden-xs-only\" src=\"" + _imports_4 + "\" data-v-388d1183> <img class=\"hidden-sm-and-up\" src=\"" + _imports_5 + "\" alt=\"\" data-v-388d1183></div><div class=\"\" data-v-388d1183><img class=\"hidden-xs-only\" src=\"" + _imports_6 + "\" data-v-388d1183> <img class=\"hidden-sm-and-up\" src=\"" + _imports_7 + "\" alt=\"\" data-v-388d1183></div>", 4);
import { useRouter } from "vue-router";
const __default__ = {
  metaInfo: {
    title: '合伙人招募-京奇数据智慧营销',
    meta: [{
      name: "description",
      content: "四川京奇数据科技有限公司诚邀各界精英加入我们的合伙人计划，共创财富未来。作为行业领先的创新型企业，我们提供AI获客系统、房产智悦拎包、京小电智慧节能等核心业务的全方位支持。凭借强大的品牌背书、市场拓展资源、技术支持和完善的运营体系，我们助力合伙人实现资源变现、业务增长和收入最大化。加入我们，开启您的创业之旅，共享行业变革带来的巨大机遇！"
    }, {
      name: "keywords",
      content: "合伙人招募、加盟合作、创业机会、房地产合伙人、大数据科技合作、AI获客系统合作、房产智悦拎包合作、智慧节能业务合作、市场拓展机会、品牌背书合作、行业创新合作、合伙人计划、创业支持、商业合作机会、财富共创、地产科技合作"
    }],
    link: [{
      rel: '',
      href: ''
    }]
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Partner',
  setup(__props) {
    const router = useRouter();
    const toUrl = () => {
      router.push({
        name: "login"
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("img", {
        class: "hidden-xs-only",
        src: _imports_8,
        style: {
          "width": "100%",
          "cursor": "pointer"
        },
        onClick: toUrl
      }), _createElementVNode("img", {
        class: "hidden-sm-and-up",
        src: _imports_9,
        style: {
          "width": "100%",
          "cursor": "pointer"
        },
        onClick: toUrl
      })]);
    };
  }
});